// Single decision point for "which saved image URL represents this layout
// version right now?" — the priority the gallery has always used:
//   1. a freshly-cached blob for this version (layoutCacheStore),
//   2. the full-res server-furnished image (furnishedImageId),
//   3. the unfurnished base image (image).
//
// This was previously inlined (identically) in getGallerySnapshot and
// downloadGalleryImage, where the two copies could drift apart. Extracting it
// here makes the choice consistent by construction. Pure and React-free so it
// stays trivially testable and safe to revert (delete file + revert callers).

/**
 * Resolve the current image URL for a layout version.
 *
 * @param {Object} args
 * @param {Object} args.layout - layout document (expects layoutsVersions[], _id)
 * @param {number} args.index  - index into layout.layoutsVersions
 * @param {{ get: (key: string) => any }} [args.cache] - layoutCacheStore-like store
 * @returns {string | undefined} the resolved image URL, or undefined if none exist
 */
export function resolveVersionImageUrl({ layout, index, cache } = {}) {
  const versionEntry = layout?.layoutsVersions?.[index];
  const version = versionEntry?.version;
  const cached = cache?.get(String(layout?._id))?.versions?.[version];

  return cached?.url || versionEntry?.furnishedImageId || versionEntry?.image;
}
